export const ConflictType = {
  diagnosis: "diagnosis",
  demographic: "demographic",
  coverage: "coverage"
};
